import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import SlideRecord from '../common/SlideRecord';
export default observer(function InstructionRecord(props) {
    return _jsx(SlideRecord, Object.assign({}, props));
});
